import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { IconButton, ListItem, ListItemAvatar, ListItemText, Stack } from "@mui/material";
import PropTypes from "prop-types";

function MemberItem({ member, intercom, intercomDispatch }) {
  const [pending, setPending] = useState(false);

  function handleMemberLeave() {
    setPending(true);

    Promise.resolve(Api.deleteIntercomMember(intercom, member))
      .then(() => intercomDispatch({ type: "removeMember", sippeerId: member.id }))
      .finally(() => setPending(false));
  }

  return (
    <ListItem
      key={member.exten}
      sx={(theme) => ({
        "&:nth-of-type(odd)": {
          backgroundColor: "#f8f8f8",
          ...theme.applyStyles("dark", {
            backgroundColor: "#28282d",
          }),
        },
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "#efefef",
          ...theme.applyStyles("dark", {
            backgroundColor: "#323237",
          }),
        },
      })}
      secondaryAction={
        <Stack
          direction="row"
          sx={{
            gap: 0.25,
          }}
        >
          <IconButton onClick={handleMemberLeave} disabled={pending}>
            <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
          </IconButton>
        </Stack>
      }
    >
      <ListItemAvatar>
        <Avatar text={member.name} />
      </ListItemAvatar>
      <ListItemText primary={member.name} secondary={member.exten} />
    </ListItem>
  );
}

MemberItem.propTypes = {
  member: PropTypes.object,
  intercom: PropTypes.object,
  intercomDispatch: PropTypes.func,
};

export default MemberItem;
